import { IDEA_STATUSES } from '@cult/domain';
import { z } from 'zod';

const STATUS_FILTER = z.enum(['', IDEA_STATUSES.PENDING, IDEA_STATUSES.APPROVED, IDEA_STATUSES.REJECTED]).catch('');

export const feedSearchSchema = z.object({
  q: z.string().catch(''),
  status: STATUS_FILTER,
});

export type FeedSearch = z.infer<typeof feedSearchSchema>;
export type StatusFilter = z.infer<typeof STATUS_FILTER>;
